<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
    style="background-color: white"
  >
    <v-row v-if="$route.name !== 'UserList'">
      <v-col cols="12" md="8">
        <v-tabs color="primary" style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;">
          <v-tab v-for="(tab, i) in tabsOrg" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-sm-right mb-4 d-flex justify-space-between">
      <filter-form-new :filter-form="filterForm" :departments="departments" />
      <v-btn
              v-if="checkAuthorization('user_create')"
              class="primary mx-0"
              @click="addNewUser"
      >
        <v-icon>mdi-plus</v-icon>Thêm Mới
      </v-btn>
    </div>
    <div>
      <v-tabs
          v-model="tab"
          grow
          @change="getUserList()">
        <v-tabs-slider></v-tabs-slider>

        <v-tab
          v-for="(item, key) in tabs"
          :key="key"
        >
          {{item}}
        </v-tab>
        
        <v-tab-item
            v-for="(item, key) in tabs"
            :key="key">
          <user-table
            v-if="users.length"
            :filter-form="filterForm"
            :users="users"
            :departments="departments"
          />
          <common-no-result
            v-if="!loading && totalItem === 0"
          />
          <v-row class="mt-0">
            <v-col
              cols="12"
              sm="6"
            />
            <v-col
              cols="12"
              sm="6"
            >
              <v-pagination
                v-if="totalItem > limit"
                v-model="currentPage"
                class="justify-sm-end"
                :length="getTotalItem(totalItem)"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
    </div>
    
<!--    <user-form :departments="departments" />-->
    <user-form-new :departments="departments" />
    <reset-password-form />
  </v-container>
</template>

<script>
  import { OrganizationMachineTabMenu } from "@/pages/organization-machine/organizationContant.js" 
  import ResetPasswordForm from './components/ResetPasswordForm'
  // import UserForm from './components/UserForm'
  import UserFormNew from './components/UserFormNew'
  import TokenService from '../../helpers/token';
  import FilterFormNew from './components/FilterFormNew.vue'
  import UserTable from './components/UserTable'
  import RepositoryFactory from '../../repositories/RepositoryFactory'

  const UserRepository = RepositoryFactory.get('user');
  const DepartmentRepository = RepositoryFactory.get('department');

  export default {
    components: { UserTable, FilterFormNew, UserFormNew, ResetPasswordForm },
    data () {
      return {
        filterForm: {},
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        users: [],
        loading: false,
        departments: [],
        tabs: ['Đang hoạt động', 'Ngừng hoạt động'],
        tab: 0,
        tabsOrg: [],
        watchModule: ''
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getUserList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getUserList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    created () {
      this.tabsOrg = OrganizationMachineTabMenu()
      this.getUserList();
      // this.getDepartmentList();
      Bus.$on('user-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getUserList()
      })
      Bus.$on('user-list-reload', () => {
        this.getUserList()
      })

      this.watchModule = this.$store.watch(
        (state) => {
          return state.module
        },
        (newVal) => {
          this.filterForm = {}
          Bus.$emit('user-list-filter', this.filterForm)
          Bus.$emit('reset-product-group-user-form')
        },
        {
          deep: true
        }
      )
    },
    beforeDestroy () {
      Bus.$off('user-list-filter')
      Bus.$off('user-list-reload')
      this.watchModule()
    },
    methods: {
      async getDepartmentList() {
        const response = await DepartmentRepository.list({limit: 100});
        if (_.get(response, 'success', false)) {
          let departments = _.get(response, 'data');
          if (!this.isManager() && !this.checkAuthorization('user_view_all')) {
            const dataUser = TokenService.getUser() || {};
            departments = departments.filter(d => d.id == dataUser.departmentId || dataUser.listDepartmentIds.includes(d.id));
          }
          this.departments = departments;
        }
      },
      addNewUser () {
        this.selectedUser = {}
        Bus.$emit('user-show-user-form-new', this.selectedUser)
      },
      async getUserList () {
        this.loading = true
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          departmentId: this.filterForm.departmentId || '',
          position: this.filterForm.position,
          status: this.tab == 0 ? 'active' : 'inactive',
          ext: this.filterForm.ext,
          callcenterId: this.filterForm.callcenterId,
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId,
          roleIds: this.filterForm?.roleIds
        }
        
        // const loader = this.$loading.show()
        this.appLoadingData(true)
        const response = await UserRepository.listV2(params)
        this.appLoadingData(false)
        // loader.hide()
        this.loading = false
        if (response.success) {
          this.users = _.get(response, 'data', []).map(u => ({
            ...u,
            productGroups: _.get(u, 'productGroups', []).map(group => group.id),
            listdepartmentId: _.get(u, 'listDepartment', []).map(item => item.departmentId),
            roleIds: _.get(u, 'userRole', []).map(item => item.roleId),
          }))
          this.totalItem = response.totalItem
        }
      },
    },
  }
</script>
